  import React, { useState, useEffect } from 'react';
  // useNavigate import removed (unused) - using hooks.useAppNavigate()
  import Cookies from 'js-cookie'; // Already imported, good.

  import { hooks } from '../hooks';
  import { custom } from '../custom';
  import { components } from '../components';
  import { SHOPIFY_STORES } from '../config';
  import ReactPhoneInput from 'react-phone-input-2';
  // Don't forget to import the CSS for the library
  import 'react-phone-input-2/lib/style.css'; 

  // Define your GraphQL mutation for updating a customer
  const CUSTOMER_UPDATE_MUTATION = `
    mutation customerUpdate($customerAccessToken: String!, $customer: CustomerUpdateInput!) {
      customerUpdate(customerAccessToken: $customerAccessToken, customer: $customer) {
        customer {
          firstName
          lastName
          phone
        }
        customerUserErrors {
          field
          message
        }
      }
    }
  `;

  // Get store config based on which store the user logged in with
  const getStoreConfig = () => {
    const storeKey = localStorage.getItem('loggedInStoreKey') || Cookies.get('loggedInStoreKey') || 'USA';
    return SHOPIFY_STORES[storeKey as keyof typeof SHOPIFY_STORES] || SHOPIFY_STORES.USA;
  };

  export const EditProfile: React.FC = () => {
    const navigate = hooks.useAppNavigate();
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');

    // --- 1. Load data from localStorage (and ensure phone is loaded) ---
    useEffect(() => {
      const storedUser = localStorage.getItem('shopifyUser');
      if (storedUser) {
        const user = JSON.parse(storedUser);
        // Ensure we load the phone number if it exists in the stored user object
        setFirstName(user?.firstName || '');
        setLastName(user?.lastName || '');
        setEmail(user?.email || '');
        setPhone(user?.phone || ''); 
      }
    }, []); 

    const renderHeader = () => {
      return <components.Header goBack={true} />;
    };

    const handleSaveProfile = async () => {
      const tokenFromLocal = typeof window !== 'undefined' ? localStorage.getItem('customerAccessToken') : null;
      const tokenFromCookie = Cookies.get('customerAccessToken');
      const accessToken = tokenFromLocal || tokenFromCookie;

      if (!accessToken) {
          alert('You must be logged in to update your profile.');
          navigate('/SignIn');
          return;
      }
        
      // Phone validation remains
      const phoneRegex = /^\+[1-9]\d{1,14}$/;

      // Shopify requires phone number to be set to null if not provided,
      // and if provided, it often requires E.164 format (which your regex matches)
      const phoneValue = phone.trim() === '+' || phone.trim() === '' ? null : phone.trim(); 

      if (phoneValue && !phoneRegex.test(phoneValue)) {
        alert('Please enter a valid phone number');
        return; 
      }

      // Build the customer update input object
      const customerInput = {
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        phone: phoneValue,
        // NOTE: Email is NOT included here as per your request
      };

      const variables = {
        customerAccessToken: accessToken,
        customer: customerInput,
      };

      try {
          const storeConfig = getStoreConfig();
          const response = await fetch(storeConfig.url, {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'X-Shopify-Storefront-Access-Token': storeConfig.token,
              },
              body: JSON.stringify({ query: CUSTOMER_UPDATE_MUTATION, variables }),
          });

          const result = await response.json();
          const updateResult = result.data.customerUpdate;
          
          console.log("Shopify Update Response:", result);

          if (updateResult.customerUserErrors && updateResult.customerUserErrors.length > 0) {
              const error = updateResult.customerUserErrors[0].message;
              alert(`Profile update failed: ${error}`);
          } else if (updateResult.customer) {
              // --- Success: Update localStorage with the new data ---
              const newUserData = {
                  ...JSON.parse(localStorage.getItem('shopifyUser') || '{}'),
                  firstName: updateResult.customer.firstName,
                  lastName: updateResult.customer.lastName,
                  phone: updateResult.customer.phone,
                  // Email remains the same as it wasn't updated
              };
              localStorage.setItem('shopifyUser', JSON.stringify(newUserData));
              
              alert('Profile updated successfully!');
              navigate('/profile');
          } else {
              // Should be covered by customerUserErrors, but as a fallback:
              alert('Profile update failed due to an unknown error.');
          }

      } catch (err) {
        console.error("Network or API Error:", err);
        alert('Network error. Could not update profile. Please try again.');
      }
    };

    const renderContent = () => {
      return (
        <div
          style={{
            paddingLeft: 20,
            paddingRight: 20,
            paddingTop: 40,
            paddingBottom: 20,
          }}
        >
          <custom.InputField
            label='First Name'
            value={firstName}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFirstName(e.target.value)}
            containerStyle={{ marginBottom: 20 }}
            placeholder='John'
          />
          <custom.InputField
            label='Last Name'
            value={lastName}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLastName(e.target.value)}
            containerStyle={{ marginBottom: 20 }}
            placeholder='Doe'
          />
          {/* --- CHANGE: Email is now Read-Only --- */}
          <custom.InputField
            label='Email'
            value={email}
            // The onChange handler is removed/disabled for a read-only field
            containerStyle={{ marginBottom: 20 }}
            placeholder='john@example.com'
            readOnly={true}
            style={{ backgroundColor: '#f0f0f0' }}
          />
          {/* --- End Change --- */}
        <ReactPhoneInput
    country={'in'} // Default country set to India (or 'us' for the US)
    value={phone}
  onChange={(value, data, event, formattedValue) => {
      // RPI-2 typically returns the full number *without* the '+', 
      // so we manually ensure the E.164 format required by your regex.
      const e164Value = '+' + value;
      setPhone(e164Value);
    }}// The library handles updating the phone state
    placeholder='Enter phone number'
    containerStyle={{ marginBottom: 20 }}
    // You might need additional styling/props to match your custom component look
  />
          
          <div style={{ marginTop: 30 }}>
            <button
              style={{
                width: '100%',
                padding: '15px',
                backgroundColor: '#5ba1c7ff',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                fontSize: '16px',
                cursor: 'pointer',
              }}
              onClick={handleSaveProfile}
            >
              Save Changes
            </button>
          </div>
        </div>
      );
    };

    const renderBottomTabBar = () => {
      return <components.BottomTabBar />;
    };

    return (
      <>
        {renderHeader()}
        {renderContent()}
        {renderBottomTabBar()}
      </>
    );
  };